import React from 'react';
import AntD from 'antd';

const antdMessage = AntD.message;
const message = {
    success: (content, ...rest) => antdMessage.success(<span role={'alert'}>{content}</span>, ...rest),
    error: (content, ...rest) => antdMessage.error(<span role={'alert'}>{content}</span>, ...rest),
    info: (content, ...rest) => antdMessage.info(<span role={'alert'}>{content}</span>, ...rest),
    warning: (content, ...rest) => antdMessage.warning(<span role={'alert'}>{content}</span>, ...rest),
    warn: (content, ...rest) => antdMessage.warn(<span role={'alert'}>{content}</span>, ...rest),
    loading: (content, ...rest) => antdMessage.loading(<span role={'alert'}>{content}</span>, ...rest),
};

export default message;
